import { render } from "./RequestLink.vue?vue&type=template&id=071e1200"
import script from "./RequestLink.vue?vue&type=script&lang=js"
export * from "./RequestLink.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__